module.exports = __webpack_public_path__ + "img/blue_135.afed008f.png";